import { format, parseISO, isValid } from 'date-fns';
import { toAccountZonedTime } from 'custom/dashboard/helper/accountTimeZone';

const toDate = value => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'number') return new Date(value);
  const parsed = parseISO(String(value));
  return isValid(parsed) ? parsed : new Date(value);
};

/**
 * Precise expiry for Pro plan card / subscription page (account timezone).
 */
export const formatBillingDateTime = (
  value,
  pattern = 'MMM d, yyyy · h:mm a'
) => {
  const date = toDate(value);
  if (!date || Number.isNaN(date.getTime())) return '';
  return format(toAccountZonedTime(date), pattern);
};

export const formatBillingDate = (value, pattern = 'MMM d, yyyy') =>
  formatBillingDateTime(value, pattern);

export const remainingSecondsUntil = endsAt => {
  const date = toDate(endsAt);
  if (!date) return 0;
  return Math.max(0, Math.floor((date.getTime() - Date.now()) / 1000));
};
